import { Backdrop } from "@mui/material";
import React, { FC } from "react";

import { CircularProgress, Stack, Typography } from "@components/base";

interface BackdropLoader {
  isVisible: boolean;
  label?: string;
}

const BackdropLoader: FC<BackdropLoader> = ({ isVisible, label }) => {
  return (
    <Backdrop
      sx={(theme) => ({
        color: theme.palette.common.white,
        zIndex: theme.zIndex.drawer + 1,
      })}
      open={isVisible}
      onClick={(e) => e.preventDefault()}
    >
      <Stack spacing={2} alignItems="center">
        <CircularProgress color="inherit" />
        {label && (
          <Typography variant="body1" color="inherit">
            {label}
          </Typography>
        )}
      </Stack>
    </Backdrop>
  );
};

export default BackdropLoader;
